import { Card, CardHeader, Divider, Typography } from "@mui/material";
import { RolesList } from "../../../components";

interface IProps {
  userGuid: string;
}

const UserRolesAgendaStep = (props: IProps) => {
  return (
    <Card>
      <CardHeader title={<Typography variant="h6">Roles</Typography>} />
      <Divider />
      <RolesList userId={props.userGuid} />
    </Card>
  );
};

export { UserRolesAgendaStep };
